// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3misx","unreadBadge":"styles_unreadBadge__3qErV","modalContent":"styles_modalContent__2KTiF","modal":"styles_modal__2FORc"};